import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { D as DomService } from './index3.js';
import { d as defineCustomElement$3 } from './roche-date2.js';
import { d as defineCustomElement$2 } from './roche-icon2.js';

const rocheSublineCss = ":host{display:block;margin-top:3rem;display:block}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .attribution-phrase{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--caption--font-size--small-up);line-height:1.1875rem;color:#9d948e;margin-bottom:1.5rem}@media (min-width: 48rem){:host .attribution-phrase{font-size:var(--caption--font-size--medium-up);line-height:1.375rem}}:host .subline-wrapper{display:flex}:host .subline-text-container{align-self:center}:host ::slotted([slot=avatar]){width:3rem;height:3rem;margin-right:1.5rem}:host .author{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-weight:400;font-size:var(--footnotes--font-size--small-up);line-height:1.1875rem;color:#544f4f}@media (min-width: 48rem){:host .author{font-size:var(--footnotes--font-size--medium-up)}}:host .author-description{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--caption--font-size--small-up);line-height:1.1875rem;color:#544f4f}@media (min-width: 48rem){:host .author-description{font-size:var(--caption--font-size--medium-up);line-height:1.375rem}}:host roche-date{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--caption--font-size--small-up);line-height:1.1875rem;color:#9d948e;margin-top:0.25rem}@media (min-width: 48rem){:host roche-date{font-size:var(--caption--font-size--medium-up);line-height:1.375rem}}:host([dir=rtl]) ::slotted([slot=avatar]){margin-left:1.5rem}";
const RocheSublineStyle0 = rocheSublineCss;

const RocheSubline$1 = /*@__PURE__*/ proxyCustomElement(class RocheSubline extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.author = undefined;
        this.authorDescription = undefined;
        this.attributionPhrase = undefined;
        this.date = undefined;
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    render() {
        return (h(Host, { key: '1a3b6c230692bd32070dbc86809684dee54b6ab3' }, this.attributionPhrase && h("div", { class: 'attribution-phrase' }, this.attributionPhrase), h("div", { key: 'bee5d80f5f783ddd7d13458f1615ffa06439462e', class: "subline-wrapper" }, h("slot", { key: 'b81134884fcec4c805afe5c5a4622af2f85662c8', name: "avatar" }), h("div", { key: '9182209ebab8c278b7b731b5c6812120d07912b1', class: 'subline-text-container' }, h("div", { key: 'a7b6d5462fd7f11e8e639ac4453292bfc9194879', class: "author" }, this.author), h("div", { key: 'ab0e33a50c336d4396d0550885657b2b6d4ae39d', class: "author-description" }, this.authorDescription), this.date && h("roche-date", { date: this.date, format: 'll' })))));
    }
    get element() { return this; }
    static get style() { return RocheSublineStyle0; }
}, [1, "roche-subline", {
        "author": [1],
        "authorDescription": [1, "author-description"],
        "attributionPhrase": [1, "attribution-phrase"],
        "date": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-subline", "roche-date", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-subline":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheSubline$1);
            }
            break;
        case "roche-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheSubline = RocheSubline$1;
const defineCustomElement = defineCustomElement$1;

export { RocheSubline, defineCustomElement };

//# sourceMappingURL=roche-subline.js.map